import { render, staticRenderFns } from "./PasswordResetNew.vue?vue&type=template&id=2d86df36&"
import script from "./PasswordResetNew.vue?vue&type=script&lang=js&"
export * from "./PasswordResetNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports